import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@akinon/next/components/lazy-component.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalDataLayer"] */ "/app/src/components/global-datalayer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/category/category-info.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/app-promo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandHome"] */ "/app/src/widgets/brand-landing/home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/app/src/widgets/brand-landing/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/brand-triple-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/collection-tabs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/combine/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/discover/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/featured-brands/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/flatpage-brands/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/four-column-content/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/hero-slider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/image/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-banner-switch-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-banner-tab-area/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/lp-cok-satanlar/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-group-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-matching-color-choices/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-shop-by-sport/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-styled-by-community/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/lp-video-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/not-found-four-column-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/product-discover-recommendation/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/product-recommendation/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/single-banner-with-countdown/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/single-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/store-list/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/store-single-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/styleguide-collection/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/toggled-text/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/triple-image-content/index.tsx");
